/* ─────────────────────────────────────────────────────────────────
   RPI Event Calendar  —  event-calendar.js
   ───────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  const MONTHS = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];
  const YEAR = 2026;
  const CAROUSEL_INTERVAL_MS = 3000;

  /* Recurring/ongoing event titles to exclude from the Past Events
     gallery — these are still active series, not one-time events. */
  const RECURRING_TITLES = [
    "greenway artisan market",
    "seaport summer market",
    "sowa open market",
    "somerville flea"
  ];

  const TYPE_MAP = {
    "artisan fair":     "artisan-fair",
    "farmer's market":  "farmers-market",
    "farmers market":   "farmers-market",
    "summer market":    "summer-market",
    "christmas market": "christmas-market",
    "winter market":    "winter-market",
    "community event":  "community-event"
  };

  const LEGEND_ITEMS = [
    { label: "Artisan Fair",     color: "#FAC775" },
    { label: "Farmer's Market",  color: "#C0DD97" },
    { label: "Summer Market",    color: "#FFF0A0" },
    { label: "Christmas Market", color: "#F4BCBC" },
    { label: "Winter Market",    color: "#B5D4F4" },
    { label: "Community Event",  color: "#F4C0D1" },
    { label: "Other Event",      color: "#D3D1C7" }
  ];

  function pad(n) { return String(n).padStart(2, '0'); }
  function dateKey(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function typeSlug(type) {
    return TYPE_MAP[(type || '').toLowerCase().trim()] || 'default';
  }
  function typeClass(type, prefix) {
    return prefix + '--' + typeSlug(type);
  }
  function buildEventMap(raw) {
    const map = {};
    (raw || []).forEach(function (ev) {
      if (!ev.date) return;
      if (!map[ev.date]) map[ev.date] = [];
      map[ev.date].push(ev);
    });
    return map;
  }

  function init() {
    const root = document.getElementById('rpi-cal-root');
    if (!root) return;

    const grid          = document.getElementById('rpi-cal-grid');
    const monthLabel    = document.getElementById('rpi-cal-month-label') || document.getElementById('rpi-month-label');
    const prevBtn       = document.getElementById('rpi-prev');
    const nextBtn       = document.getElementById('rpi-next');
    const carouselWrap  = document.getElementById('rpi-cal-carousel-wrap');
    const carouselTrack = document.getElementById('rpi-cal-carousel-track');
    const carouselDots  = document.getElementById('rpi-cal-carousel-dots');
    const pastSection   = document.getElementById('rpi-cal-past-section');
    const pastGrid      = document.getElementById('rpi-cal-past-grid');
    const modalOverlay  = document.getElementById('rpi-cal-modal-overlay');
    const modalBody     = document.getElementById('rpi-cal-modal-body');
    const modalClose    = document.getElementById('rpi-cal-modal-close');

    const eventMap   = buildEventMap(window.__RPI_EVENTS__);
    const today      = new Date();
    let currentMonth = (today.getFullYear() === YEAR) ? today.getMonth() : 0;
    let selectedKey  = null;

    /* ── Legend ─────────────────────────────────────────────── */
    const legendEl = document.createElement('div');
    legendEl.className = 'rpi-cal-legend';
    legendEl.id = 'rpi-cal-legend';
    legendEl.innerHTML = LEGEND_ITEMS.map(function (item) {
      return (
        '<div class="rpi-cal-legend-item">' +
          '<span class="rpi-cal-legend-dot" style="background:' + item.color + '"></span>' +
          '<span>' + item.label + '</span>' +
        '</div>'
      );
    }).join('');

    /* Scrolls so the TOP of the carousel is visible, with a small
       offset for any sticky header, instead of "nearest edge"
       which can leave the slide half cut off.                    */
    function scrollToCarouselTop() {
      const rect = carouselWrap.getBoundingClientRect();
      const offset = 90;
      const targetY = window.pageYOffset + rect.top - offset;
      window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
    }

    /* ───────────────────────────────────────────────────────────
       EVENT DETAIL MODAL
       Opens for any event clicked from the carousel or past list.
       ─────────────────────────────────────────────────────────── */
    function openModal(ev, dateRangeOverride) {
      const imageHTML = (ev.image && ev.image !== 'null' && ev.image.trim() !== '')
        ? '<img class="rpi-cal-modal-image" src="' + esc(ev.image) + '" alt="' + esc(ev.title) + '">'
        : '<div class="rpi-cal-modal-image-placeholder">&#127881;</div>';

      const timeStr = (ev.start && ev.end)
        ? esc(ev.start) + ' \u2013 ' + esc(ev.end)
        : esc(ev.start) || '';

      const typeLabel = (ev.type && ev.type.trim() !== '') ? esc(ev.type) : 'Event';

      const whenStr = dateRangeOverride
        ? esc(dateRangeOverride)
        : (function () {
            const parts = ev.date.split('-');
            const d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
            return esc(d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }));
          })();

      const metaRows = [];
      metaRows.push('<div class="rpi-cal-modal-meta-row"><span class="rpi-cal-modal-meta-icon">&#128197;</span><span class="rpi-cal-modal-meta-text">' + whenStr + '</span></div>');
      if (timeStr) {
        metaRows.push('<div class="rpi-cal-modal-meta-row"><span class="rpi-cal-modal-meta-icon">&#9201;</span><span class="rpi-cal-modal-meta-text">' + timeStr + '</span></div>');
      }
      if (ev.location && ev.location.trim() !== '') {
        metaRows.push('<div class="rpi-cal-modal-meta-row"><span class="rpi-cal-modal-meta-icon">&#128205;</span><span class="rpi-cal-modal-meta-text">' + esc(ev.location) + '</span></div>');
      }
      if (ev.address && ev.address.trim() !== '') {
        metaRows.push('<div class="rpi-cal-modal-meta-row"><span class="rpi-cal-modal-meta-icon">&#127968;</span><span class="rpi-cal-modal-meta-text">' + esc(ev.address) + '</span></div>');
      }

      const websiteHTML = (ev.website && ev.website.trim() !== '')
        ? '<a class="rpi-cal-modal-link" href="' + esc(ev.website) + '" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;gap:10px;color:#ffffff;background:#8B1A1A;padding:14px 28px;border-radius:12px;text-decoration:none;font-size:1.2rem;font-weight:700;">' +
          '<span style="font-size:1.3rem;">&#127760;</span>' +
          '<span style="color:#ffffff;font-weight:700;font-size:1.2rem;">Learn more</span>' +
          '</a>'
        : '';

      modalBody.innerHTML =
        imageHTML +
        '<div class="rpi-cal-modal-content">' +
          '<div class="rpi-cal-modal-badge-row">' +
            '<span class="rpi-cal-modal-type ' + typeClass(ev.type, 'rpi-type') + '">' + typeLabel + '</span>' +
          '</div>' +
          '<h2 class="rpi-cal-modal-title" id="rpi-modal-title">' + esc(ev.title) + '</h2>' +
          '<div class="rpi-cal-modal-meta">' + metaRows.join('') + '</div>' +
          (ev.desc ? '<p class="rpi-cal-modal-desc">' + esc(ev.desc) + '</p>' : '') +
          websiteHTML +
        '</div>';

      modalOverlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      stopCarouselTimerSafe();
    }

    function closeModal() {
      modalOverlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
      startCarouselTimerSafe();
    }

    function stopCarouselTimerSafe() {
      if (typeof stopCarouselTimer === 'function') stopCarouselTimer();
    }
    function startCarouselTimerSafe() {
      if (typeof startCarouselTimer === 'function') startCarouselTimer();
    }

    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modalOverlay.hasAttribute('hidden')) closeModal();
    });

    /* ───────────────────────────────────────────────────────────
       CAROUSEL
       ─────────────────────────────────────────────────────────── */
    let slideEvents   = [];
    let currentSlide  = 0;
    let carouselTimer = null;
    let pinnedSlides  = [];   // events forced to the front when a day is clicked

    /* Dedupe repeating events (Greenway, Seaport, SoWa, etc.) by
       title — keep only the soonest upcoming instance of each.   */
    function buildUpcomingDeduped() {
      const now      = new Date();
      const todayStr = dateKey(now.getFullYear(), now.getMonth(), now.getDate());
      const allDates = Object.keys(eventMap).sort();
      const future   = allDates.filter(function (d) { return d >= todayStr; });

      const seenTitles = {};
      const list = [];

      future.forEach(function (d) {
        eventMap[d].forEach(function (ev) {
          const titleKey = (ev.title || '').toLowerCase().trim();
          if (seenTitles[titleKey]) return;
          seenTitles[titleKey] = true;
          list.push(ev);
        });
      });

      return list;
    }

    function daysAwayLabel(dateStr) {
      const now    = new Date();
      const todayD = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const parts  = dateStr.split('-');
      const evD    = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      const diff   = Math.round((evD - todayD) / (1000 * 60 * 60 * 24));
      if (diff === 0) return 'Today';
      if (diff === 1) return 'Tomorrow';
      if (diff < 0)   return Math.abs(diff) + (diff === -1 ? ' day ago' : ' days ago');
      return diff + ' days away';
    }

    function formatSlideDate(dateStr) {
      const parts = dateStr.split('-');
      const d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    }

    function buildSlide(ev, isFirst, isPinned) {
      const imageHTML = (ev.image && ev.image !== 'null' && ev.image.trim() !== '')
        ? '<img class="rpi-cal-slide-image" src="' + esc(ev.image) + '" alt="' + esc(ev.title) + '" loading="lazy">'
        : '<div class="rpi-cal-slide-image-placeholder">&#127881;</div>';

      const timeStr = (ev.start && ev.end)
        ? esc(ev.start) + ' \u2013 ' + esc(ev.end)
        : esc(ev.start) || '';

      const typeLabel = (ev.type && ev.type.trim() !== '') ? esc(ev.type) : 'Event';

      const websiteHTML = (ev.website && ev.website.trim() !== '')
        ? '<a class="rpi-cal-slide-link" href="' + esc(ev.website) + '" target="_blank" rel="noopener noreferrer">&#127760;&nbsp;Learn more</a>'
        : '';

      let badgeHTML = '';
      if (isPinned) {
        badgeHTML = '<span class="rpi-cal-slide-selected-tag">&#128197; Selected day</span>';
      } else if (isFirst) {
        badgeHTML = '<span class="rpi-cal-slide-upcoming">&#9733; Upcoming</span>';
      }

      return (
        '<div class="rpi-cal-slide" data-date="' + esc(ev.date) + '">' +
          imageHTML +
          '<div class="rpi-cal-slide-body">' +
            '<div class="rpi-cal-slide-badge-row">' +
              badgeHTML +
              '<span class="rpi-cal-slide-type ' + typeClass(ev.type, 'rpi-type') + '">' + typeLabel + '</span>' +
              '<span class="rpi-cal-slide-days">' + daysAwayLabel(ev.date) + '</span>' +
            '</div>' +
            '<div class="rpi-cal-slide-title">' + esc(ev.title) + '</div>' +
            '<div class="rpi-cal-slide-meta">' +
              esc(formatSlideDate(ev.date)) +
              (timeStr ? '<span class="rpi-cal-slide-meta-divider">&middot;</span>' + timeStr : '') +
              (ev.location ? '<span class="rpi-cal-slide-meta-divider">&middot;</span>&#128205;&nbsp;' + esc(ev.location) : '') +
            '</div>' +
            (ev.desc ? '<p class="rpi-cal-slide-desc">' + esc(ev.desc) + '</p>' : '') +
            websiteHTML +
          '</div>' +
        '</div>'
      );
    }

    function goToSlide(index) {
      if (slideEvents.length === 0) return;
      currentSlide = ((index % slideEvents.length) + slideEvents.length) % slideEvents.length;
      carouselTrack.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';

      const dots = carouselDots.querySelectorAll('.rpi-cal-carousel-dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('rpi-cal-carousel-dot--active', i === currentSlide);
      });
    }

    function advanceSlide() {
      goToSlide(currentSlide + 1);
    }

    function startCarouselTimer() {
      stopCarouselTimer();
      if (slideEvents.length <= 1) return;
      carouselTimer = window.setInterval(advanceSlide, CAROUSEL_INTERVAL_MS);
    }

    function stopCarouselTimer() {
      if (carouselTimer !== null) {
        window.clearInterval(carouselTimer);
        carouselTimer = null;
      }
    }

    let hoverDepth = 0;
    function handleMouseEnter() {
      hoverDepth++;
      stopCarouselTimer();
    }
    function handleMouseLeave() {
      hoverDepth = Math.max(0, hoverDepth - 1);
      if (hoverDepth === 0) startCarouselTimer();
    }

    /* Rebuild the carousel. If pinnedSlides is non-empty (user just
       clicked a day), those events go first, marked "Selected day",
       followed by the deduped upcoming list (skipping duplicates of
       whatever's already pinned by title).                          */
    function renderCarousel(jumpToStart) {
      const upcoming = buildUpcomingDeduped();

      let combined = [];
      const pinnedTitles = {};

      pinnedSlides.forEach(function (ev) {
        const key = (ev.title || '').toLowerCase().trim();
        pinnedTitles[key] = true;
        combined.push({ ev: ev, pinned: true });
      });

      upcoming.forEach(function (ev) {
        const key = (ev.title || '').toLowerCase().trim();
        if (pinnedTitles[key]) return;
        combined.push({ ev: ev, pinned: false });
      });

      if (combined.length === 0) {
        carouselWrap.setAttribute('hidden', '');
        return;
      }

      slideEvents = combined.map(function (c) { return c.ev; });

      carouselTrack.innerHTML = combined.map(function (c, i) {
        const isFirstUnpinned = !c.pinned && pinnedSlides.length === 0 && i === 0;
        return buildSlide(c.ev, isFirstUnpinned, c.pinned);
      }).join('');

      carouselDots.innerHTML = slideEvents.map(function (_, i) {
        return '<button class="rpi-cal-carousel-dot" data-index="' + i + '" aria-label="Go to slide ' + (i + 1) + '"></button>';
      }).join('');

      carouselWrap.querySelectorAll('.rpi-cal-carousel-arrow').forEach(function (el) { el.remove(); });

      if (slideEvents.length > 1) {
        const prevArrow = document.createElement('button');
        prevArrow.className = 'rpi-cal-carousel-arrow rpi-cal-carousel-arrow--prev';
        prevArrow.setAttribute('aria-label', 'Previous event');
        prevArrow.innerHTML = '&#8249;';
        prevArrow.addEventListener('click', function () {
          goToSlide(currentSlide - 1);
          startCarouselTimer();
        });

        const nextArrow = document.createElement('button');
        nextArrow.className = 'rpi-cal-carousel-arrow rpi-cal-carousel-arrow--next';
        nextArrow.setAttribute('aria-label', 'Next event');
        nextArrow.innerHTML = '&#8250;';
        nextArrow.addEventListener('click', function () {
          goToSlide(currentSlide + 1);
          startCarouselTimer();
        });

        carouselWrap.appendChild(prevArrow);
        carouselWrap.appendChild(nextArrow);
      }

      carouselDots.querySelectorAll('.rpi-cal-carousel-dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          goToSlide(parseInt(dot.getAttribute('data-index')));
          startCarouselTimer();
        });
      });

      carouselTrack.querySelectorAll('.rpi-cal-slide').forEach(function (slideEl, i) {
        slideEl.style.cursor = 'pointer';
        slideEl.addEventListener('click', function (e) {
          if (e.target.closest('.rpi-cal-slide-link')) return;
          openModal(slideEvents[i]);
        });
      });

      carouselWrap.removeAttribute('hidden');
      goToSlide(jumpToStart ? 0 : currentSlide);
      startCarouselTimer();
    }

    carouselWrap.addEventListener('mouseenter', handleMouseEnter);
    carouselWrap.addEventListener('mouseleave', handleMouseLeave);

    /* ───────────────────────────────────────────────────────────
       PAST EVENTS GALLERY
       Shows one-time events whose date has already passed.
       Excludes recurring/ongoing series (Greenway, Seaport, etc.)
       ─────────────────────────────────────────────────────────── */
    function isRecurringTitle(title) {
      const key = (title || '').toLowerCase().trim();
      return RECURRING_TITLES.indexOf(key) !== -1;
    }

    /* Strips a trailing "— Day N" / "- Day N" / ": Day N" suffix
       so multi-day events (CT Flower Show Day 1-4, NE Christmas
       Festival Day 1-3, etc.) collapse under one grouping key.   */
    function baseTitleKey(title) {
      return (title || '')
        .toLowerCase()
        .replace(/[\u2013\u2014:\-]\s*day\s*\d+\s*$/i, '')
        .trim();
    }
    function baseTitleDisplay(title) {
      return (title || '')
        .replace(/[\u2013\u2014:\-]\s*Day\s*\d+\s*$/i, '')
        .trim();
    }

    function buildPastList() {
      const now      = new Date();
      const todayStr = dateKey(now.getFullYear(), now.getMonth(), now.getDate());
      const allDates = Object.keys(eventMap).sort();
      const past     = allDates.filter(function (d) { return d < todayStr; });

      const groups = {};
      const order  = [];

      past.forEach(function (d) {
        eventMap[d].forEach(function (ev) {
          if (isRecurringTitle(ev.title)) return;
          const key = baseTitleKey(ev.title);
          if (!groups[key]) {
            groups[key] = {
              title: baseTitleDisplay(ev.title),
              type: ev.type,
              image: ev.image,
              location: ev.location,
              address: ev.address,
              desc: ev.desc,
              start: ev.start,
              end: ev.end,
              website: ev.website,
              dates: []
            };
            order.push(key);
          }
          groups[key].dates.push(d);
          if (!groups[key].image || groups[key].image === 'null') {
            groups[key].image = ev.image;
          }
          if (!groups[key].website && ev.website) groups[key].website = ev.website;
          if (!groups[key].address && ev.address) groups[key].address = ev.address;
        });
      });

      order.sort(function (a, b) {
        const lastA = groups[a].dates[groups[a].dates.length - 1];
        const lastB = groups[b].dates[groups[b].dates.length - 1];
        return lastA < lastB ? 1 : (lastA > lastB ? -1 : 0);
      });

      return order.map(function (key) { return groups[key]; });
    }

    function formatDateRange(dates) {
      const sorted = dates.slice().sort();
      const first = sorted[0];
      const last  = sorted[sorted.length - 1];

      const fp = first.split('-');
      const lp = last.split('-');
      const fd = new Date(parseInt(fp[0]), parseInt(fp[1]) - 1, parseInt(fp[2]));
      const ld = new Date(parseInt(lp[0]), parseInt(lp[1]) - 1, parseInt(lp[2]));

      if (first === last) {
        return fd.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      }

      const sameMonth = fd.getMonth() === ld.getMonth() && fd.getFullYear() === ld.getFullYear();
      if (sameMonth) {
        const monthName = fd.toLocaleDateString('en-US', { month: 'long' });
        return monthName + ' ' + fd.getDate() + '\u2013' + ld.getDate() + ', ' + fd.getFullYear();
      }

      const fStr = fd.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
      const lStr = ld.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      return fStr + ' \u2013 ' + lStr;
    }

    function pastTypeSlug(type) {
      return typeSlug(type);
    }

    function buildPastCard(group) {
      const imageHTML = (group.image && group.image !== 'null' && group.image.trim() !== '')
        ? '<img class="rpi-cal-past-thumb" src="' + esc(group.image) + '" alt="' + esc(group.title) + '" loading="lazy">'
        : '<div class="rpi-cal-past-thumb-placeholder">&#128247;</div>';

      const displayDate = formatDateRange(group.dates);
      const typeLabel   = (group.type && group.type.trim() !== '') ? esc(group.type) : 'Event';
      const slug        = pastTypeSlug(group.type);

      return (
        '<div class="rpi-cal-past-row">' +
          '<div class="rpi-cal-past-accent rpi-accent--' + slug + '"></div>' +
          imageHTML +
          '<div class="rpi-cal-past-body">' +
            '<div class="rpi-cal-past-title">' + esc(group.title) + '</div>' +
            '<div class="rpi-cal-past-meta">' +
              '<span>&#128197;&nbsp;' + esc(displayDate) + '</span>' +
              (group.location
                ? '<span class="rpi-cal-past-meta-dot">&middot;</span><span>&#128205;&nbsp;' + esc(group.location) + '</span>'
                : '') +
            '</div>' +
          '</div>' +
          '<div class="rpi-cal-past-right">' +
            '<span class="rpi-cal-past-badge rpi-past-badge--' + slug + '">' + typeLabel + '</span>' +
            '<span class="rpi-cal-past-arrow">&#8250;</span>' +
          '</div>' +
        '</div>'
      );
    }

    function renderPastEvents() {
      const pastList = buildPastList();

      if (pastList.length === 0) {
        pastSection.setAttribute('hidden', '');
        return;
      }

      pastGrid.innerHTML = pastList.map(buildPastCard).join('');

      var subheading = pastSection.querySelector('.rpi-cal-past-subheading');
      if (!subheading) {
        subheading = document.createElement('p');
        subheading.className = 'rpi-cal-past-subheading';
        subheading.textContent = 'Click any event to see full details.';
        var heading = pastSection.querySelector('.rpi-cal-past-heading');
        heading.parentNode.insertBefore(subheading, pastGrid);
      }

      pastSection.removeAttribute('hidden');

      pastGrid.querySelectorAll('.rpi-cal-past-row').forEach(function (rowEl, i) {
        rowEl.style.cursor = 'pointer';
        rowEl.addEventListener('click', function () {
          const group = pastList[i];
          const fakeEvent = {
            title: group.title,
            type: group.type,
            image: group.image,
            location: group.location,
            address: group.address,
            desc: group.desc,
            start: group.start,
            end: group.end,
            website: group.website,
            date: group.dates[0]
          };
          openModal(fakeEvent, formatDateRange(group.dates));
        });
      });
    }

    /* ── Render calendar grid ───────────────────────────────── */
    function render() {
      monthLabel.textContent = MONTHS[currentMonth] + ' ' + YEAR;
      grid.innerHTML = '';

      const firstDay    = new Date(YEAR, currentMonth, 1).getDay();
      const daysInMonth = new Date(YEAR, currentMonth + 1, 0).getDate();
      const daysInPrev  = new Date(YEAR, currentMonth, 0).getDate();
      const isThisMonth = (today.getFullYear() === YEAR && today.getMonth() === currentMonth);
      const totalCells  = Math.ceil((firstDay + daysInMonth) / 7) * 7;

      for (let i = 0; i < totalCells; i++) {
        let day, month, year, other = false;
        if (i < firstDay) {
          day = daysInPrev - firstDay + i + 1;
          month = currentMonth - 1; year = YEAR;
          if (month < 0) { month = 11; year--; }
          other = true;
        } else if (i >= firstDay + daysInMonth) {
          day = i - firstDay - daysInMonth + 1;
          month = currentMonth + 1; year = YEAR;
          if (month > 11) { month = 0; year++; }
          other = true;
        } else {
          day = i - firstDay + 1;
          month = currentMonth; year = YEAR;
        }

        const key    = dateKey(year, month, day);
        const events = eventMap[key] || [];

        const cell = document.createElement('div');
        cell.className = 'rpi-cal-day';
        cell.setAttribute('role', 'gridcell');
        cell.setAttribute('aria-label',
          MONTHS[month] + ' ' + day +
          (events.length ? ', ' + events.length + ' event' + (events.length > 1 ? 's' : '') : '')
        );

        if (other)  cell.classList.add('rpi-cal-day--other');
        if (!other && isThisMonth && day === today.getDate()) cell.classList.add('rpi-cal-day--today');
        if (events.length)       cell.classList.add('rpi-cal-day--events');
        if (selectedKey === key) cell.classList.add('rpi-cal-day--selected');

        const num = document.createElement('span');
        num.className   = 'rpi-cal-daynum';
        num.textContent = day;
        cell.appendChild(num);

        const MAX = 2;
        events.slice(0, MAX).forEach(function (ev) {
          const pill = document.createElement('span');
          pill.className   = 'rpi-cal-pill ' + typeClass(ev.type, 'rpi-pill');
          pill.textContent = ev.title;
          cell.appendChild(pill);
        });
        if (events.length > MAX) {
          const more = document.createElement('span');
          more.className   = 'rpi-cal-more';
          more.textContent = '+' + (events.length - MAX) + ' more';
          cell.appendChild(more);
        }

        if (events.length) {
          cell.addEventListener('click', function () {
            if (selectedKey === key) {
              selectedKey = null;
              pinnedSlides = [];
              render();
              renderCarousel(true);
              return;
            }
            selectedKey = key;
            pinnedSlides = events.slice();
            render();
            renderCarousel(true);
            scrollToCarouselTop();
          });
        }

        grid.appendChild(cell);
      }

      if (!document.getElementById('rpi-cal-legend')) {
        grid.parentNode.insertBefore(legendEl, grid.nextSibling);
      }
    }

    /* ── Navigation ─────────────────────────────────────────── */
    prevBtn.addEventListener('click', function () {
      currentMonth = (currentMonth - 1 + 12) % 12;
      render();
    });
    nextBtn.addEventListener('click', function () {
      currentMonth = (currentMonth + 1) % 12;
      render();
    });

    /* ── First paint ────────────────────────────────────────── */
    renderCarousel(true);
    render();
    renderPastEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();